import("../src/javascripts/navigation");
import("../src/javascripts/easy-toggle");
import('../src/javascripts/slider_splide');
import("../src/javascripts/smooth-scroll-to-anchor");

// for form attachments
import("../src/javascripts/attachments-redesign");
